import { enableAutoTrack, makeTracker } from './auto';
import { type Events } from './events';
import { mixpanel } from './mixpanel';
import { sentry } from './sentry';
import {
  track as aliTrack,
  initTracking,
  setUserId,
  getTracker,
} from './ali-init';
import {
  initConsoleCapture,
  getConsoleCapture,
  flushConsoleLogs,
  destroyConsoleCapture,
  type ConsoleCaptureConfig,
  type LogLevel,
  type LogEntry,
} from './console-capture';

export const track = makeTracker((event, props) => {
  // mixpanel.track(event, props);
  aliTrack(event, props);
});

export {
  aliTrack,
  type ConsoleCaptureConfig,
  destroyConsoleCapture,
  enableAutoTrack,
  type Events,
  flushConsoleLogs,
  getConsoleCapture,
  getTracker,
  // Console 日志捕获相关导出
  initConsoleCapture,
  initTracking,
  type LogEntry,
  type LogLevel,
  mixpanel,
  sentry,
  setUserId,
};
export default track;
